<template>
  <div class="legal-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    
    <!-- Hero Section avec design du screenshot -->
    <section class="legal-hero" style="padding-top: 140px; padding-bottom: 80px; background: #FFFFFF;">
      <div class="container">
        <div class="row align-items-center">
          <!-- Contenu gauche -->
          <div class="col-lg-6">
            <h1 class="legal-title mb-4">
              Mentions légales
              <svg class="title-underline" viewBox="0 0 200 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4C45 2 155 2 198 6" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h1>
            
            <p class="legal-text mb-4" style="color: #8B8B8B; font-size: 0.95rem; line-height: 1.7;">
              Nolido Cash est une société informatique de distribution de monnaie électronique dont le siège est basé au Bénin. Nous mettons à la disposition de nos Clients répondant à la définition du terme « Utilisateur » telle que précisée dans les conditions d'utilisations Générale, les solutions dénommées « NOLIDO » et « Nolido Money Transfer ».
            </p>
            
            <p class="legal-text mb-4" style="color: #8B8B8B; font-size: 0.95rem; line-height: 1.7;">
              Ces services vous permettent d'envoyer de l'argent à vos proches ou de faire une simple interopérabilité entre wallets. La distribution du service est faite en accord avec des Prestataires ou Services financiers désignés dans les Pays de destination actuellement disponible sur Nolido Cash. La Solution Nolido Money Transfer est conçue dans le but de favoriser des transferts simples, économique, rapide, fiable vers l'Afrique et en Afrique.
            </p>
            
            <p class="legal-text mb-4" style="color: #8B8B8B; font-size: 0.95rem; line-height: 1.7;">
              Conformément au Règlement relatif aux systèmes de paiement dans les États membres de l'UEMOA et de l'instruction N-11-2015 relative aux modalités d'exercice de l'activité de transfert rapide d'argent en qualité de sous-agent au sein de l'Union Monétaire Ouest Africaine et à l'instruction n°008-05-2015 réglissant les conditions et modalités d'exercice des activités des émetteurs de monnaie électronique dans les états membres de l'union monétaire ouest africaine (UMOA), la société Nolido Cash, est habilitée à faire de la distribution de Monnaie Électronique.
            </p>
            
            <div class="d-flex align-items-center mt-4" style="color: #8B8B8B; font-size: 0.85rem;">
              <i class="bi bi-clock-history me-2"></i>
              <span><strong>Dernière mise à jour :</strong> 30 Juillet 2023</span>
            </div>
          </div>
          
          <!-- Image iPhone droite -->
          <div class="col-lg-6 text-center">
            <div class="phone-mockup-container">
              <img :src="require('@/assets/img/iphone.png')" alt="Nolido App" class="phone-mockup-legal">
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Composants requis -->
    <testimonials-section />
    <faq-section />
    <cta-section />
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';
import CtaSection from '@/components/CtaSection.vue';

export default {
  name: 'LegalPage',
  components: {
    Navbar,
    AppFooter,
    TestimonialsSection,
    FaqSection,
    CtaSection
  }
}
</script>

<style scoped>
.legal-page {
  background: #FFFFFF;
}

.legal-hero {
  min-height: 80vh;
  display: flex;
  align-items: center;
}

.legal-title {
  font-size: 3rem;
  font-weight: 800;
  color: #2F2113;
  line-height: 1.2;
  position: relative;
  display: inline-block;
  margin-bottom: 2rem;
}

.title-underline {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  max-width: 200px;
  height: auto;
}

.legal-text {
  font-size: 0.95rem;
  color: #8B8B8B;
  line-height: 1.7;
}

.phone-mockup-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone-mockup-legal {
  max-width: 400px;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 60px rgba(0,0,0,0.2));
}

@media (max-width: 992px) {
  .legal-title {
    font-size: 2.5rem;
  }
  
  .legal-hero {
    padding-top: 100px;
    padding-bottom: 60px;
  }
  
  .phone-mockup-legal {
    max-width: 300px;
    margin-top: 3rem;
  }
}

@media (max-width: 768px) {
  .legal-title {
    font-size: 2rem;
  }
  
  .legal-text {
    font-size: 0.9rem;
  }
  
  .phone-mockup-legal {
    max-width: 250px;
  }
}
</style>